"use client";

/**
 * A way in to the settings sheet from anywhere under the shell.
 *
 * The sheet's open state belongs to `PortalShell`, because the two controls
 * that open it — the rail's identity row and the header's gear — are the
 * shell's own chrome. A page underneath sometimes needs the same door: Home
 * prompts for a missing handle, and the prompt has to reach a dialog the page
 * does not own.
 *
 * A context rather than a prop through `children`: the shell renders pages as
 * `children` and has no prop to hand them.
 */

import { createContext, useContext } from "react";

const PortalSettingsContext = createContext<{ open: () => void } | null>(null);

export const PortalSettingsProvider = PortalSettingsContext.Provider;

/**
 * Null outside the shell — the prototype renders these screens without one.
 * Callers treat that as "there is no sheet here" and leave the affordance out,
 * rather than rendering a control that does nothing.
 */
export function usePortalSettings() {
  return useContext(PortalSettingsContext);
}
